"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccessControlUpgradeableFactory", {
  enumerable: true,
  get: function get() {
    return _AccessControlUpgradeable__factory.AccessControlUpgradeable__factory;
  }
});
Object.defineProperty(exports, "IAccessControlUpgradeableFactory", {
  enumerable: true,
  get: function get() {
    return _IAccessControlUpgradeable__factory.IAccessControlUpgradeable__factory;
  }
});
Object.defineProperty(exports, "OwnableUpgradeableFactory", {
  enumerable: true,
  get: function get() {
    return _OwnableUpgradeable__factory.OwnableUpgradeable__factory;
  }
});
Object.defineProperty(exports, "ERC165UpgradeableFactory", {
  enumerable: true,
  get: function get() {
    return _ERC165Upgradeable__factory.ERC165Upgradeable__factory;
  }
});
Object.defineProperty(exports, "IERC165UpgradeableFactory", {
  enumerable: true,
  get: function get() {
    return _IERC165Upgradeable__factory.IERC165Upgradeable__factory;
  }
});
Object.defineProperty(exports, "OwnableFactory", {
  enumerable: true,
  get: function get() {
    return _Ownable__factory.Ownable__factory;
  }
});
Object.defineProperty(exports, "DocumentStoreAccessControlFactory", {
  enumerable: true,
  get: function get() {
    return _DocumentStoreAccessControl__factory.DocumentStoreAccessControl__factory;
  }
});
Object.defineProperty(exports, "BaseDocumentStoreFactory", {
  enumerable: true,
  get: function get() {
    return _BaseDocumentStore__factory.BaseDocumentStore__factory;
  }
});
Object.defineProperty(exports, "DocumentStoreFactory", {
  enumerable: true,
  get: function get() {
    return _DocumentStore__factory.DocumentStore__factory;
  }
});
Object.defineProperty(exports, "DocumentStoreCreatorFactory", {
  enumerable: true,
  get: function get() {
    return _DocumentStoreCreator__factory.DocumentStoreCreator__factory;
  }
});
Object.defineProperty(exports, "DocumentStoreWithRevokeReasonsFactory", {
  enumerable: true,
  get: function get() {
    return _DocumentStoreWithRevokeReasons__factory.DocumentStoreWithRevokeReasons__factory;
  }
});

var _AccessControlUpgradeable__factory = require("./factories/AccessControlUpgradeable__factory");

var _IAccessControlUpgradeable__factory = require("./factories/IAccessControlUpgradeable__factory");

var _OwnableUpgradeable__factory = require("./factories/OwnableUpgradeable__factory");

var _ERC165Upgradeable__factory = require("./factories/ERC165Upgradeable__factory");

var _IERC165Upgradeable__factory = require("./factories/IERC165Upgradeable__factory");

var _Ownable__factory = require("./factories/Ownable__factory");

var _DocumentStoreAccessControl__factory = require("./factories/DocumentStoreAccessControl__factory");

var _BaseDocumentStore__factory = require("./factories/BaseDocumentStore__factory");

var _DocumentStore__factory = require("./factories/DocumentStore__factory");

var _DocumentStoreCreator__factory = require("./factories/DocumentStoreCreator__factory");

var _DocumentStoreWithRevokeReasons__factory = require("./factories/DocumentStoreWithRevokeReasons__factory");